<app-bread-crumb [items]="[{text:'quotas'}]" [sectionTitle]="'Lista de Todos Quotas'"></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">

      <!-- inicio do box -->
      <ng-box [boxIcon]="'fa fa-dollar'" [boxTitle]="'Quotas'">

        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">

          <ng-button *ngIf="isAdminOrUserKhuzela()" (click)="create()"
            [button]="{name:'nova quota', faIconClass:'fa fa-plus',color:'danger'}">
          </ng-button>

        </ng-container>

        <!-- box-content -->
        <ng-container class="ng-box-content">

          <!-- inicio da tabela -->
          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

            <tr *ngFor="let quote of objects" ngChangeColorOnHover>
              <td>{{quote?.quota_description}}</td>
              <td>{{quote?.quota_value | currency:'MZN':symbol}}</td>
              <td>{{quote?.payment_date}}</td>
              <td>{{quote?.period?.name}}</td>

              <td *ngIf="isAdminOrUserKhuzela()">
                <strong [ngStyle]="{color: '#f35309'}">{{quote?.club?.name}}</strong>
              </td>

              <!-- controles -->
              <ng-actions-table-bar *ngIf="isAdminOrUserKhuzela()">

                <ng-button title="Editar" (click)="edit(quote)" [button]="{faIconClass:'fa fa-edit',color:'danger'}">
                </ng-button>

                <ng-button title="Excluir" (click)="delete(quote)"
                  [button]="{faIconClass:'fa fa-close',color:'danger'}"></ng-button>

              </ng-actions-table-bar>

            </tr>

          </ng-table>
          <!-- fim da tabela -->

          <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>

        </ng-container>
        <!-- fim do conteudo do box -->
      </ng-box>
      <!-- fim do box -->
    </div>
  </div>
</section>
